import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import type { LifeReadinessCategoryCardProps } from './CategoryCard';

export const useAgentContext = (props: LifeReadinessCategoryCardProps) => {
  useRegisterAgentContext({
    kind: 'visual',
    label: props.title,
    display: props.showCta
      ? 'Category card showing a sticker image, title, and either progress bars with level counts or a description with a "Start Now" button'
      : props.onClick
        ? 'Category card showing a sticker image, title, and either progress bars with level counts or a description. Clicking it opens the recorded answers for this category; it has no "Start Now" button.'
        : 'Category card showing a sticker image, title, and either progress bars with level counts or a description. It is not clickable and has no "Start Now" button.',
    data: {
      title: props.title,
      description: props.description,
      progress: props.progress,
    },
  });
};
